module.exports = __webpack_public_path__ + "6073ddcffcc7c715883b34f702bef924.svg";